module.exports = __webpack_public_path__ + "static/media/car-pink-only.0e9dff26.svg";